import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import lodash from "lodash";
import vuetify from "./plugins/vuetify";
import VideoBg from "vue-videobg";
import VueWebP from "v-webp";
Vue.component("video-bg", VideoBg);
import VueRecaptcha from "vue-recaptcha";

Vue.use(Vuex);
Vue.use(VueWebP);
Vue.config.productionTip = false;
Vue.component("vue-recaptcha", VueRecaptcha);

import store from "./stores";

new Vue({
  router,
  lodash,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
